import React from 'react';
import { useNavigate } from 'react-router-dom';

const FormSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f5f5f5',
      padding: '20px',
    }}>
      <div style={{
        backgroundColor: '#fff',
        borderRadius: '16px',
        padding: '60px 40px',
        maxWidth: '550px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
      }}>
        <div style={{
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          backgroundColor: '#28a745',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 30px',
          fontSize: '50px',
          color: '#fff',
        }}>
          &#10003;
        </div>

        <h1 style={{
          fontSize: '32px',
          color: '#333',
          marginBottom: '16px',
          fontWeight: 'bold',
        }}>
          Form Submitted Successfully!
        </h1>

        <p style={{
          fontSize: '18px',
          color: '#666',
          marginBottom: '40px',
          lineHeight: '1.6',
        }}>
          Thank you for your quote request. We'll contact you soon with the best price for your recovery needs.
        </p>

        <button
          onClick={() => navigate('/')}
          style={{
            padding: '14px 36px',
            border: 'none',
            borderRadius: '8px',
            backgroundColor: '#FFF222',
            color: '#333',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
          }}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default FormSuccess;
